import axios from "axios";

const API =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const initializeYear = async (year) => {
  const { data } = await axiosInstance.post("/academic-calendar/initialize", { year });
  return data;
};

export const getToday = async () => {
  const { data } = await axiosInstance.get("/academic-calendar/today");
  return data;
};

export const getMonth = async (year, month) => {
  const { data } = await axiosInstance.get(`/academic-calendar/month/${year}/${month}`);
  return data;
};

export const getYearSummary = async (year) => {
  const { data } = await axiosInstance.get(`/academic-calendar/year/${year}`);
  return data;
};

export const markDay = async (payload) => {
  const { data } = await axiosInstance.post("/academic-calendar/mark", payload);
  return data;
};

export const markDaysRange = async (payload) => {
  const { data } = await axiosInstance.post("/academic-calendar/mark-range", payload);
  return data;
};

export const resetDay = async (date) => {
  const { data } = await axiosInstance.delete(`/academic-calendar/reset/${date}`);
  return data;
};
